export class Outlet {
    constructor(
      public enabled?: boolean,
      public outletName?: string,
      public operatingUnit?: string,
      public updateAt?: number,
      public createAt?: number,
      public address?: string,
      public id?: string,
      public region?: number | string,
      public country?: string,
      public campaignList?: any[],
      public iconUrl?: string,
      public modifiedBy?: string
    ) { }
  }
  


// WEBPACK FOOTER //
// ./src/app/modules/outlet/outlet.model.ts